import React from 'react';
import { connect } from 'react-redux';
import { JobNoteCard } from '../Notes';

const JobNoteCards = ({ project, notes, handleEdit }) => {
  return(
    <div>
      {notes &&
        notes.map((note, i) => {
          return <JobNoteCard key={i} note={note} handleEdit={handleEdit}/>;
        })
      }
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const id = props.project.id;
  return ({
    projectTasks: state.projectTasksState.filter( projectTask => projectTask.projectId == id),
    notes: state.notesState.filter ( note => note.projectId == id)
  });
}

export default connect(mapStateToProps)(JobNoteCards);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Notes/JobNoteCards.jsx